import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TransactionsInfoList from '@/features/finances/components/Transactions/TransactionsInfo/TransactionsInfoList';
import { cn } from '@/lib/utils';

type Props = {
	className?: string;
	isMobile?: boolean;
};

const FinancesPageTransactions: FC<Props> = ({ className, isMobile }) => {
	const { t } = useTranslation();

	return (
		<div
			className={cn(
				'w-full p-6 flex flex-col gap-6 border border-popover-100 rounded-2.5xl bg-popover-10',
				isMobile && 'p-0 border-0 bg-popover-30 gap-4',
				className
			)}>
			<div className='flex items-center justify-between gap-4'>
				<h4
					className={cn(
						'text-xl font-medium',
						isMobile && 'text-lg',
					)}>
					{t('main.finances.components.transactions.title')}
				</h4>
			</div>
			<div className='flex flex-col'>
				<TransactionsInfoList isMobile={isMobile} />
			</div>
		</div>
	);
};

export default FinancesPageTransactions;
